import { QPanel } from "./QPanel";

export class QParkingPanel extends QPanel {
  constructor() {
    super();
    this.fWSMgr = null;
  }

  InitializePanel(wsMgr) {
    this.fWSMgr = wsMgr;
  }
}
